<template>
    <v-container flat>
        <v-row
            no-gutters
            v-if="missingAccountingPeriodLaps && missingAccountingPeriodLaps.length"
            class="d-flex justify-center"
        >
            <v-col
                :cols="$vuetify.display.mobile ? '12' : '8'"
                v-for="(lap, index) in missingAccountingPeriodLaps"
                :key="index"
            >
                <v-card class="default_card ma-0" elevation="0" pa-0 style="margin: 5px">
                    <!-- @click="openAccountingPeriod(ap)" -->
                    <v-row class="d-flex align-center" no-gutters>
                        <!-- ** icon -->
                        <v-col
                            cols="1"
                            class="d-flex justify-center align-center"
                            v-if="!$vuetify.display.mobile"
                        >
                            <v-icon color="primary" size="x-large"> $fa-info-circle </v-icon>
                        </v-col>

                        <v-col cols="1" class="d-flex justify-center align-center"> </v-col>

                        <!-- ** dates -->
                        <v-col :cols="$vuetify.display.mobile ? '8' : '7'">
                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex align-center justify-start">
                                    <span
                                        :class="
                                            $vuetify.display.mobile
                                                ? 'ml-2 text-primary'
                                                : 'text-primary'
                                        "
                                        style="font-weight: bold; font-size: 16pt"
                                    >
                                        Du {{ formatDate(lap.start) }} au {{ formatDate(lap.end) }}
                                    </span>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="auto" class="d-flex align-center justify-start">
                                    <strong class="text-primary">
                                        Période sans exercices comptables</strong
                                    >
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="1" class="d-flex justify-center align-center"> </v-col>

                        <v-col cols="1" class="d-flex justify-center align-center"> </v-col>

                        <v-col cols="1" class="d-flex justify-center align-center">
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon v-bind="props" icon="$oss-help" color="primary" />
                                </template>

                                <div>
                                    <p>Vous pouvez :</p>
                                    <p>
                                        - si les exercices, avant ou après, ne sont pas clôturés,
                                        les modifier et étendre,
                                    </p>
                                    <p>- sinon, créer des nouveaux exercices</p>
                                </div>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";

import { Vue, toNative } from "vue-facing-decorator";
import { Prop, Component } from "vue-facing-decorator";

@Component
export class AccountingPeriodsMissingLaps extends Vue {
    @Prop({ default: null }) missingAccountingPeriodLaps: Array<any>;

    formatDate(date) {
        if (!date) return null;
        return moment(date).format("DD-MM-YYYY");
    }
}

export default toNative(AccountingPeriodsMissingLaps);
</script>
